export default {
  message: {},
  alerts: [],
  count_alerts: 0,
  pagination: {},
};
